<template>
  <div>
    <div class="auth-callback d-flex flex-column align-items-center justify-content-center">
      <div v-if="store.isLoading" class="text-center">
        <div class="spinner-border fa-3x" role="status">
          <span class="visually-hidden">Caricamento...</span>
        </div>
        <p class="mt-3">Autenticazione in corso, attendere prego...</p>
      </div>

      <div v-else-if="store.authError" class="text-center">
        <i class="fas fa-exclamation-triangle fa-3x text-danger"></i>
        <h3 class="mt-3">Errore di Autenticazione</h3>
        <p>{{ store.authError }}</p>
        <button @click="goHome" class="btn btn-primary mt-2">
          <i class="fas fa-home me-1"></i>
          Torna alla Home
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>

import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from '../stores/app.js'
const store = useAppStore()
const router = useRouter()
const goHome = () => {
  router.push('/')
}

onMounted( async () => {
  // Logica di callback di autenticazione verrà implementata qui
  await store.resolveCodeOAuth2();

  if(store.authError){
    console.error("Errore di autenticazione:", store.authError);
    return;
  }
  goHome();
})



</script>
<ascript>
import { ref, onMounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAppStore } from '../stores/app.js'

export default {
  name: 'AuthCallback',
  setup() {
    const router = useRouter()
    const route = useRoute()
    const appStore = useAppStore()
    
    const isLoading = ref(true)
    const error = ref(null)
    
    const userName = computed(() => appStore.getUserName)

    const goHome = () => {
      router.push('/')
    }

    const processAuthCallback = async () => {
        console.log('🔐 Inizio processAuthCallback')
        isLoading.value = true
        error.value = null

        // Estrai i parametri dall'URL
        const urlParams = new URLSearchParams(window.location.search)
        const code = urlParams.get('code')
        const state = urlParams.get('state')
        const errorParam = urlParams.get('error')

        console.log('📋 Parametri URL:', { code: code?.substring(0, 10) + '...', state, error: errorParam })

        // Verifica se ci sono errori
        if (errorParam) {
          throw new Error(`Errore OAuth2: ${errorParam} - ${urlParams.get('error_description')}`)
        }

        // Verifica lo state per sicurezza
        const savedState = sessionStorage.getItem('oauth_state')
        console.log('🔒 Verifica state:', { received: state, saved: savedState })
        
        if (!state || state !== savedState) {
          throw new Error('State OAuth2 non valido - possibile attacco CSRF')
        }

        if (!code) {
          throw new Error('Codice di autorizzazione mancante')
        }

        console.log('🚀 Autenticazione tramite server con code:', code.substring(0, 20) + '...')
        
        // Prima assicuriamoci di avere la configurazione del server per il redirect URI
        if (!appStore.hasServerConfig) {
          console.log('Caricamento configurazione server...')
          await appStore.fetchServerConfig()
        }
        
        const authConfig = appStore.getAuthConfig
        if (!authConfig || !authConfig.redirect_uri) {
          throw new Error('Configurazione OAuth2 o redirect URI non disponibile')
        }
        
        // Invia il code al server tramite l'endpoint health con tutti i parametri necessari
        const healthParams = new URLSearchParams({
          code: code,
          state: state,
          redirect_uri: authConfig.redirect_uri
        })
        
        const healthUrl = `${appStore.apiBaseUrl}/config?${healthParams.toString()}`
        console.log('📡 Chiamata a:', healthUrl)
        
        const response = await fetch(healthUrl)
        
        if (!response.ok) {
          throw new Error(`Errore server: ${response.status}`)
        }
        
        const result = await response.json()
        console.log('📨 Risposta server:', result)
        
        // Verifica se l'autenticazione è riuscita
        if (result.user == null) {
          throw new Error(`Autenticazione fallita: ${result.authentication?.error || 'Motivo sconosciuto'}`)
        }
        
        console.log('✅ Autenticazione completata:', result.user)
        
        // Salva i token e le info utente
        if (result.tokens) {
          saveTokens(result.tokens)
          console.log('💾 Token salvati')
        }
        
        if (result.user) {
          appStore.setUser(result.user)
          console.log('👤 Utente salvato nello store')
        }

        // Pulisci il sessionStorage
        sessionStorage.removeItem('oauth_state')
        sessionStorage.removeItem('oauth_nonce')

        console.log('🎉 Login completato:', result.user)
        
        // Attendi un momento per mostrare il successo
        setTimeout(() => {
          // Redirect alla home o alla pagina originale
          const redirectTo = sessionStorage.getItem('auth_redirect_to') || '/'
          sessionStorage.removeItem('auth_redirect_to')
          console.log('🔄 Redirect a:', redirectTo)
          router.push(redirectTo)
        }, 2000)
        
      // } catch (err) {
      //   console.error('❌ Errore nel callback OAuth2:', err)
      //   error.value = err.message || 'Errore sconosciuto durante l\'autenticazione'
      // } finally {
        isLoading.value = false
      // }
    }

    const saveTokens = (tokens) => {
      if (tokens.access_token) {
        localStorage.setItem('access_token', tokens.access_token)
      }
      if (tokens.refresh_token) {
        localStorage.setItem('refresh_token', tokens.refresh_token)
      }
      if (tokens.id_token) {
        localStorage.setItem('id_token', tokens.id_token)
      }
      
      // Salva la data di scadenza
      if (tokens.expires_in) {
        const expiresAt = Date.now() + (tokens.expires_in * 1000)
        localStorage.setItem('token_expires_at', expiresAt.toString())
      }
    }

    onMounted(() => {
      console.log('🔄 AuthCallback component mounted')
      console.log('Current URL:', window.location.href)
      console.log('Current route:', router.currentRoute.value)
      processAuthCallback()
    })

    return {
      isLoading,
      error,
      userName,
      goHome
    }
  }
}
</ascript>

<style scoped>
.auth-callback {
  min-height: 60vh;
  display: flex;
  align-items: center;
}

.fa-3x {
  font-size: 3rem;
}
</style>